import viewerDefault from './viewerDefault'
import linkViewers from '../linkViewers'
import multiViewControls from '../multiViewControls'
import viewerSplit from './viewerSplit'
import viewerLayers from './viewerLayers'
import viewerOnPremises from './viewerOnPremises'

const DEFAULT_INITIAL_POSITION = { available: false }

function init(data, customUIName, largeIcons, initialPosition = DEFAULT_INITIAL_POSITION, tenantViewerAssets) {
  if (!data.maxZoomLevelPercentage || data.maxZoomLevelPercentage <= 0) {
    data.maxZoomLevelPercentage = 100
  }

  viewerDefault.createViewerDom(data, largeIcons, tenantViewerAssets)
  return viewerDefault.createViewer(data, customUIName, largeIcons, initialPosition)
}

function replaceElementToEnsureNoGarbageEventListenersAreLeftInRemovedViewers(element) {
  if (element) {
    element.classList.remove('active')
    element.replaceWith(element.cloneNode(true))
  }
}

function cleanViewers(viewersList, imagesData) {
  const rulerButton = document.getElementById('ruler')

  let navigatorWithButtons = document.getElementById('navigatorWithButtons')
  if (navigatorWithButtons) navigatorWithButtons.remove()

  imagesData.forEach((viewer, index) => {
    let currentViewer = document.getElementById(viewer.viewerId)
    if (currentViewer) currentViewer.remove()
  })

  let viewer = document.getElementById(`viewer`)
  if (viewer) viewer.remove()

  const controlsContainer = document.getElementById('controlsContainer')
  if (controlsContainer) controlsContainer.remove()

  viewersList.forEach(viewer => viewer.destroy())

  const rotateButton = document.getElementById('rotate')
  const fullScreenButton = document.getElementById('full-page')
  const homeButton = document.getElementById('home')
  const buttonsToClean = [rotateButton, rulerButton, fullScreenButton, homeButton]
  buttonsToClean.forEach(button => replaceElementToEnsureNoGarbageEventListenersAreLeftInRemovedViewers(button))
}

function createViewerDefault(
  imagesData,
  customUIName,
  updatedNumberOfViewersAtRuntime,
  largeIcons,
  initialPosition = DEFAULT_INITIAL_POSITION,
  tenantViewerAssets
) {
  let viewersList = []

  imagesData.forEach((data, index) => {
    if (updatedNumberOfViewersAtRuntime) {
      data.percentage = 100 / updatedNumberOfViewersAtRuntime
      data.left = data.percentage * index
    }
    const viewer = init(data, customUIName, largeIcons, initialPosition, tenantViewerAssets)

    viewersList.push(viewer)
  })
  linkViewers.init(viewersList)
  multiViewControls.createDom(imagesData)
  return viewersList
}

function createViewerSplit(imagesData) {
  return viewerSplit.init(imagesData)
}

function createViewerLayers(imagesData) {
  return viewerLayers.init(imagesData)
}

function createViewerOnPremises(imagesData, kioskData) {
  return viewerOnPremises.createViewers(imagesData, kioskData)
}

function resetViewerRotation(viewer) {
  viewer.viewport.setRotation(360)
}

export default {
  DEFAULT_INITIAL_POSITION,
  createViewerDefault,
  createViewerSplit,
  createViewerLayers,
  createViewerOnPremises,
  cleanViewers,
  resetViewerRotation
}
